import React from 'react';
import { useAccessSharingFlowContext } from 'app/hooks/access-sharing';
import { ACCESS_SHARING_FLEET_STEPS } from 'app/constants/access-sharing';
import { FleetSelectionView } from 'app/components/access-sharing/flows';
import { useTranslation } from 'react-i18next';

interface Props {
  equipmentName: string;
  fleets: any[];
  onBack: () => void;
}

export default function FleetSelectionStepController({
  equipmentName,
  fleets,
  onBack,
}: Props) {
  const {
    stepper,
    isEditing,
    setIsEditing,
    selectedFleetId,
    setSelectedFleetId,
    setSelectedFleetName,
  } = useAccessSharingFlowContext();

  const { t } = useTranslation();

  const { setStep } = stepper;

  function handlePrevStep() {
    if (isEditing) {
      setStep(ACCESS_SHARING_FLEET_STEPS.OVERVIEW);
      setIsEditing(false);
    } else {
      onBack();
    }
  }

  function handleCreateFleet() {
    setSelectedFleetName('');
    setStep(ACCESS_SHARING_FLEET_STEPS.FLEET_CREATION);
  }

  function handleNextStep() {
    if (isEditing) {
      setStep(ACCESS_SHARING_FLEET_STEPS.OVERVIEW);
      setIsEditing(false);
    } else {
      setStep(ACCESS_SHARING_FLEET_STEPS.EQUIPMENT_ADDED);
    }
  }

  return (
    <FleetSelectionView
      title={t('access_sharing.flows.fleet_selection.add_to_existing', {
        equipment: equipmentName,
      })}
      fleets={fleets}
      selectedFleetId={selectedFleetId}
      setSelectedFleetId={id => {
        setSelectedFleetId(id);

        const fleet = fleets.find(
          fleet => fleet.sharedItemDetails.exposedId === id,
        );
        setSelectedFleetName(fleet.name);
      }}
      onBack={handlePrevStep}
      onCreateFleet={isEditing ? undefined : handleCreateFleet}
      onNextStep={handleNextStep}
    />
  );
}
